import { Box, Text } from "@mantine/core";
import Image from "next/image";
import { memo, useEffect, useState } from "react";

import styles from "./StyledBadge.module.scss";

const StyledBadge = ({ rarity, text }: { rarity: number; text: string }) => {
  const [badgeRankItem, setBadgeRankItem] = useState<{
    image: string;
    textStyle: string;
  }>({ image: "", textStyle: "" });

  useEffect(() => {
    const addBadgeRankItem = () => {
      switch (rarity) {
        case 1:
          setBadgeRankItem({
            image: "/images/commonbadge.png",
            textStyle: styles.commonBadgeText,
          });
          break;
        case 2:
          setBadgeRankItem({
            image: "/images/uncommonbadge.png",
            textStyle: styles.badgeText,
          });
          break;
        case 3:
          setBadgeRankItem({
            image: "/images/rarebadge.png",
            textStyle: styles.badgeText,
          });
          break;
      }
    };
    addBadgeRankItem();
  }, [rarity]);

  return (
    <Box className={styles.badge}>
      <Image
        className={styles.badgeImage}
        src={badgeRankItem.image || "/images/commonbadge.png"}
        alt="バッジ"
        width={150}
        height={32}
      />
      <Text className={badgeRankItem.textStyle}>{text}</Text>
    </Box>
  );
};

export const StyledBadgeMemo = memo(StyledBadge);
